import Relationships from 'shared_src/dictionaries/demographics/Insurance'

import { transform } from './mapper.js'
import { isSystemManaged } from './utils.js'

const responsePath = txt => [
  'contained',
  { resourceType: 'QuestionnaireResponse' },
  'item',
  { text: txt },
  'answer',
  0,
  'valueString'
]

const mkResponseMapping = (formAttr, question) => ({
  fhir: responsePath(question),
  form: [ formAttr ]
})

const mapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'Coverage'
  },
  {
    fhir: [ 'contained', { resourceType: 'QuestionnaireResponse' }, 'status' ],
    fhir_const: 'in-progress'
  },
  {
    fhir: [ 'status' ],
    fhir_const: 'active'
  },
  {
    fhir: [ 'id' ],
    form: [ 'id' ]
  },
  {
    fhir: [ 'identifier', { use: 'official' }, 'value' ],
    form: [ 'subscriberName' ]
  },
  {
    fhir: [ 'identifier', { use: 'official' }, 'type', 'text' ],
    form: [ 'subscriberNumber' ]
  },
  {
    fhir: [ 'group' ],
    form: [ 'groupNumber' ]
  },
  mkResponseMapping('phoneNumber', 'Contact Info'),
  mkResponseMapping('provider', 'Carrier Name'),
  mkResponseMapping('primaryOrSecondary', 'PrimaryOrSecondary'),
  {
    fhir: [ 'plan' ],
    form: [ 'plan' ]
  },
  {
    fhir: [ 'period', 'start' ],
    form: [ 'eligibilityStart' ]
  },
  {
    fhir: [ 'period', 'end' ],
    form: [ 'eligibilityEnd' ]
  },
  {
    fhir: [ 'beneficiaryIdentifier', { use: 'official' }, 'value' ],
    form: [ 'memberId' ]
  },
  {
    fhir: [
      'extension',
      { url: 'https://narushealth.com/coverage-dependent-id' },
      'valueString'
    ],
    form: [ 'dependentId' ]
  },
  {
    fhir: [ 'relationship' ],
    form: [ 'relationship' ],
    to_form: x => x.code,
    to_fhir: x => ({
      system: 'http://hl7.org/fhir/policyholder-relationship',
      code: x,
      display: Relationships.find(r => r.value === x).label
    })
  },
  isSystemManaged
]

export function map (ptId, data) {
  const res = transform(data, mapping, [ 'form', 'fhir' ])
  const ptRef = { reference: `Patient/${ptId}` }
  res.beneficiaryReference = ptRef
  const benId =
    res.beneficiaryIdentifier && res.beneficiaryIdentifier.length
      ? res.beneficiaryIdentifier[0]
      : null
  if (benId) {
    res.beneficiaryIdentifier = benId
  } else {
    delete res.beneficiaryIdentifier
  }
  return res
}

export function unmap (data) {
  const benId = data.beneficiaryIdentifier

  data.beneficiaryIdentifier = [ benId ]
  return transform(data, mapping, [ 'fhir', 'form' ])
}

export function mapInsuranceToPost (patientId, insurance) {
  return map(patientId, insurance)
}

export function mapInsuranceToPut (patientId, insurance) {
  return map(patientId, insurance)
}

export function mapInsuranceToForm (insurances) {
  return insurances.map(unmap)
}
